import coreReducer from './coreSlice'
import buildingReducer from './buildingSlice'
import buildingsReducer from './buildingsSlice'

import systemReducer from './systemSlice'

import regionsReducer from './regionsSlice'
import buildingTypeReducer from './buildingTypesSlice'
import alarmsReducer from './alarmsSlice'

import datePickerReducer from './datePickerSlice'
import postReducer from './postSlice'

import holidayReducer from './holidaySlice'

import themeReducer from './themeSlice'


const rootReducer = {
    core: coreReducer,
    theme: themeReducer,
    buildings: buildingsReducer,
    building: buildingReducer,
    system: systemReducer,
    regions: regionsReducer,
    holiday: holidayReducer,
    building_types: buildingTypeReducer,
    alarms: alarmsReducer,
    datePicker: datePickerReducer,
    post: postReducer
}

export default rootReducer